import { useForm } from 'react-hook-form'
import { Box, TextField, Typography } from '@mui/material'
import formErrorMessages from '../utils/formErrorMessages'
import SaveCancelFormActions from './SaveCancelFormActions'
import theme from '../theme'

type Props = {
  name: string
  onToggleEdit: (fieldName: 'name' | void) => void
  onSubmit: (formValues: { name: string }) => void
  isEditing?: boolean
  isDisabled?: boolean
}

const EditNameField = (props: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<{ name: string }>()
  const errorMessage = errors.name?.message

  return (
    <Box
      component='form'
      onSubmit={handleSubmit(props.onSubmit)}
      onClick={!props.isEditing ? () => props.onToggleEdit('name') : undefined}
      sx={{
        marginBottom: theme.spacing(4),
        opacity: props.isDisabled ? 0.1 : 1,
        cursor: !props.isEditing ? 'pointer' : ''
      }}
    >
      <Box display='flex'>
        <Box flex={props.isEditing ? 'auto' : undefined}>
          {!props.isEditing && (
            <Typography variant='h4' component='h1'>
              {props.name}
            </Typography>
          )}

          {props.isEditing && (
            <TextField
              defaultValue={props.name}
              fullWidth
              variant='filled'
              {...register('name', {
                required: formErrorMessages.required
              })}
              error={!!errorMessage}
              helperText={errorMessage || ' '}
              disabled={props.isDisabled}
              autoFocus
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '2rem',
                  paddingTop: theme.spacing(1)
                }
              }}
            />
          )}
        </Box>
      </Box>

      {props.isEditing && (
        <SaveCancelFormActions onClickCancel={props.onToggleEdit} />
      )}
    </Box>
  )
}

export default EditNameField
